/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GalleryPaginateResponse } from '../../models/gallery-paginate-response';

export interface GetGalleryIndex$Params {

/**
 * Pagination offset
 */
  page?: number;

/**
 * Pagination limit
 */
  limit?: number;

/**
 * Pagination order field ascending
 */
  orderAsc?: 'id' | 'name' | 'label' | 'description' | 'descriptionMeta' | 'createdAt' | 'updatedAt';

/**
 * Pagination order field descending
 */
  orderDesc?: 'id' | 'name' | 'label' | 'description' | 'descriptionMeta' | 'createdAt' | 'updatedAt';

/**
 * Filter by a single camp name
 */
  camp?: string;

/**
 * Filter by a gallery name
 */
  name?: string;

/**
 * Filter by gallery label
 */
  label?: number;
}

export function getGalleryIndex(http: HttpClient, rootUrl: string, params?: GetGalleryIndex$Params, context?: HttpContext): Observable<StrictHttpResponse<GalleryPaginateResponse>> {
  const rb = new RequestBuilder(rootUrl, getGalleryIndex.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('orderAsc', params.orderAsc, {});
    rb.query('orderDesc', params.orderDesc, {});
    rb.query('camp', params.camp, {});
    rb.query('name', params.name, {});
    rb.query('label', params.label, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GalleryPaginateResponse>;
    })
  );
}

getGalleryIndex.PATH = '/v1/gallery';
